import { ChartPpfIcon } from './ChartPpfIcon';

/**
 * author: Simran
 * id 42A6B073-CC7E-4539-9313-E60FAE81BC70
 * name chart-ppf
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-ppf.svg
 * tags
 * - Math 
 */
export const GraphPpfIcon = ChartPpfIcon;
export default GraphPpfIcon